import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// TODO: Replace the following with your app's Firebase project configuration
// See: https://firebase.google.com/docs/web/learn-more#config-object
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDi0znf2YxeIJdxfKPcywItH_NusiAbe2E",
    authDomain: "url-compresser.firebaseapp.com",
    databaseURL: "https://url-compresser-default-rtdb.firebaseio.com",
    projectId: "url-compresser",
    storageBucket: "url-compresser.appspot.com",
    messagingSenderId: "871510877877",
    appId: "1:871510877877:web:17637557da1231730900fc",
    measurementId: "G-LJLRQQ3GZB"
  };
// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Initialize Realtime Database and get a reference to the service
export const db = getDatabase(app);
